

function JoinUs(props) {
  return 'JoinUs'
}
export default JoinUs;